/**
 * Shared filtering for the trust pickers on the transaction cards (OWA-1803, OWA-1524).
 *
 * The filter runs on the whole merged list, with or without a Case. It used to be attached to only the
 * client-first list, so a Case context skipped it and a transfer could pick the same trust on both sides.
 */

export interface TrustPickerOption {
    id: string;
    balance: number;
}

export interface TrustPickerRules {
    /** The trust on the other side of the transfer; it is never offered. */
    excludeId?: string;
    /** Options must hold at least this much, except the ones in keepIds. A missing or NaN amount counts as zero. */
    minBalance?: number;
    /** Currently selected ids stay visible even when they cannot cover the amount. */
    keepIds?: (string | undefined)[];
}

export function filterTrustOptions<T extends TrustPickerOption>(options: T[], rules: TrustPickerRules): T[] {
    const min = Number.isFinite(rules.minBalance) ? (rules.minBalance as number) : 0;
    return options.filter(obj => {
        if (rules.excludeId && obj.id === rules.excludeId) return false;
        if (rules.keepIds?.includes(obj.id)) return true;
        return obj.balance >= min;
    });
}
